import { isNative } from 'src/utils/platform';
import { useEffect, FunctionComponent } from 'react';
import { SafeArea, SystemBarsStyle } from '@capacitor-community/safe-area';

export const Style = {
  Light: SystemBarsStyle.Light,
  Dark: SystemBarsStyle.Dark,
  Default: SystemBarsStyle.Default,
} as const;

export type StatusBarStyle = (typeof Style)[keyof typeof Style];

let appliedStyle: SystemBarsStyle | null = null;
let pageStyle: SystemBarsStyle | null = null;
const transientStyles: { style: SystemBarsStyle }[] = [];

const apply = (style: SystemBarsStyle) => {
  appliedStyle = style;
  SafeArea.setSystemBarsStyle({
    style,
    type: undefined,
  });
};

type Props = {
  style: SystemBarsStyle;
  isTransient?: boolean;
};

const StatusBar: FunctionComponent<Props> = ({
  style,
  isTransient = false,
}) => {
  useEffect(() => {
    if (!isNative()) {
      return;
    }
    if (!isTransient) {
      pageStyle = style;
      if (transientStyles.length === 0) apply(style);
      return;
    }
    if (transientStyles.length === 0) pageStyle = appliedStyle;
    const entry = { style };
    transientStyles.push(entry);
    apply(style);
    return () => {
      transientStyles.splice(transientStyles.indexOf(entry), 1);
      const next =
        transientStyles[transientStyles.length - 1]?.style ?? pageStyle;
      if (next !== null && next !== appliedStyle) apply(next);
    };
  }, [style, isTransient]);

  return null;
};

export default StatusBar;
